/**
 * InappSubscription entity class
 */

/**
 * InappSubscriptionFactory
 * returns InappSubscription entity class
 *
 * @class InappSubscriptionFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.InappSubscription} class
 *
 * @ngdoc factory
 * @name mwApp.factory:InappSubscriptionFactory
 */
/* @ngInject */
export default function InappSubscriptionFactory ($q, Entity, Type) {
  /* === InappSubscription class === */

  /**
   * InappSubscription model
   *
   * @class InappSubscription
   * @classdesc InappSubscription model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.InappSubscription} InappSubscription entity
   */
  function InappSubscription () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  InappSubscription.prototype = Object.create(Entity.prototype)
  InappSubscription.prototype.constructor = InappSubscription

  /* === InappSubscription instance methods & fields === */

  Object.assign(InappSubscription.prototype, {

    /**
     * instance fields
     *
     * @memberof models.InappSubscription#
     * @type {Object}
     */
    _fields: {
      enabled: Boolean,
      subscriptionActivationOption: String,
      subscriptions: [{id: Number, name: String, sortOrder: Number, active: Boolean }],
    },

    /**
     * url template
     *
     * @memberof models.InappSubscription#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::networkId}}/subscriptions/settings'

  })

  /* === InappSubscription static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(InappSubscription, Entity)
  InappSubscription._name = 'InappSubscription'
  InappSubscription.init()

  // permissions
  // InappSubscription.access = {
  //   view: 'viewCatchup',
  //   create: 'createCatchup',
  //   edit: 'editCatchup',
  //   delete: 'deleteCatchup'
  // }

  // extra
  InappSubscription.extra = {
    networks: [Type.Stump('Network', ['id', 'name'])],
    subscriptions: [Type.Stump('Subscription', ['id', 'name'])],
    timeUnits: [String]
  }

  /**
   * Current in-app settings
   */
  InappSubscription._current = null

  /**
   * Force load in-app settings
   *
   * @memberof models.InappSubscription
   * @return {Promise} promise
   */
  InappSubscription.forceLoad = function () {
    return this.load()
      .then((data) => {
        this._current = angular.copy(data)
        return data
      })
  }

  /**
   * Lazy load in-app settings
   * Warning! Returns plain object, not instance of InappSubscription!
   *
   * @memberof models.InappSubscription
   * @return {Promise} promise
   */
  InappSubscription.lazyLoad = function () {
    return this._current !== null
      ? $q.when(this._current)
      : this.forceLoad()
  }

  /**
   * Save in-app settings
   *
   * @memberof models.InappSubscription
   * @param {Object} settings - in-app settings
   * @return {Promise} promise
   */
  InappSubscription.save = function (settings) {
    return settings._save()
      .then(() => {
        this._current = angular.copy(settings)
        return settings
      })
  }

  return InappSubscription
}
